
























import { Component, Vue, Prop } from 'vue-property-decorator';
import LoginButton from '../components/login/LoginButton.vue';
import Email from '../components/login/Email.vue';
import Password from '../components/login/Password.vue';
import { State, Getter, Mutation, Action} from 'vuex-class';
import router from '../router';
import { actions } from '../stores/login/actions';
import { mutations } from '../stores/login/mutations';
import { LoginState } from '../stores/login/types';
import firebase from 'firebase';
import {FirebaseConnection, Config, Authentications} from '../Classes/Infrastractures';

const namespace = 'login';

@Component({
    components: {
        LoginButton,
        Email,
        Password
    },
})
export default class Login extends Vue {
    private email?:string; 

    private password?:string; 

    @Getter('loginSTS', { namespace }) 
    public loginSTS!: boolean;

    @Mutation('onAuthStateChanged', { namespace })
    private onAuthStateChanged!: any;

    @Action('authChange', { namespace })
    private authChange!: any;

    private connection = new FirebaseConnection(firebase);

    async created() {
      // TODO 環境設定ファイルに移動
      const firebaseConfig = {
        apiKey: "AIzaSyCItnagbfLWbdQfBPBBYT4P86bKbP0Xn2c",
        authDomain: "fusatou-67104.firebaseapp.com",
        databaseURL: "https://fusatou-67104.firebaseio.com",
        projectId: "fusatou-67104",
        storageBucket: "fusatou-67104.appspot.com",
        messagingSenderId: "161825891600",
        appId: "1:161825891600:web:6e07b5be1a59821f"
      }; 

      const config = new Config(firebaseConfig);
      config.init(this.connection);

      const self = this;
      await firebase.auth().onAuthStateChanged((user)=> {
        if (user) {
          self.authChange();
          router.push('./init');
        }
      })
    }

    public onEmailInputed(text:string):void {
      this.email = text;
    }

    public onPasswordInputed(text:string):void {
      this.password = text;
    }

    public async onLoginButtonClicked(){
      const self = this;
      const promise = this.login();
      promise.then(async (value) => {
        if (value) {
          self.authChange();
          router.push('./init');
        }
      }, (error) => {
        console.error("error:", error.message);
      });

    }

    private async login ():Promise<boolean> {
      const authentication = new Authentications({
        email: this.email,
        password: this.password
      });
      
      return await authentication.login(this.connection);
    }
}
